import { YMaps, Map, Placemark } from 'react-yandex-maps';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadObjects, getTotalPreview, getPreview} from "./../../actions/actions";
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Header from './../Header';
import Footer from './../Footer';
import { Link } from 'react-router-dom';
import SearchBar from './../controls/SearchControl.jsx'
import Pager from './../controls/Pager';
import {Map as LeafletMap, Marker, TileLayer, Popup} from 'react-leaflet'
import MarkerClusterGroup from './MarkerClusterGroup';


const styles = theme => ({
    root: {
        width: '100%',
        gridColumnStart: 2,
        gridColumnEnd: 4,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },

    resetPadding: {
        padding: 0,
    },
    newColor: {
        borderRadius: 0,
        backgroundColor: 'transparent',
        borderBottom: '1px solid #76b5b8',
        boxShadow: 'none',
        '&::before': {
            height: 0
        },
    },
    color:{
        color:'#76b5b8'
    },
    title:{
        color:'#76b5b8',
        textOverflow: 'ellipsis',
        maxWidth: '95%'
    },
    headerStatic:{
        margin: '60px 0',
        fontSize: 26,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 'bold'
    },
    subHeader:{
        fontSize: 18,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 'bold',
        margin: '0 0 15 0'
    },
    textStatic:{
        margin: '60px 0',
        maxWidth: '65%',
        color: '#5b5b5b'
    },
    blockDescription:{
        marginTop: '30px',
        marginBottom: '20px',
        display: 'block',
        width: '100%'
    },
    list: {
        margin: '30 0 65 0'
    },
    maps:{
        width: '100%',display: 'block',margin: '85 0 30 0','&:nth-child(1)':{
            marginRight: 'auto',
            marginLeft: 'auto'
        }
    }
});


const ObjectsMap = ({objects = []}) => {
    const markers = objects.map((coord) => {
        if (coord.object_address_lon && coord.object_address_lat) {
            let lon = parseFloat(coord.object_address_lon);
            let lat = parseFloat(coord.object_address_lat);
            let dateRegistration = null;
            if (coord.registration_date) {
                dateRegistration = <div><span>Дата регистрации:</span>{ typeof coord.registration_date.date != 'undefined' ? coord.registration_date.date.substr(0, 10): 'не указана'}</div>;
            }
            if (lon && lat) {
                return (
                    <Marker position={[lon, lat]}>
                        <Popup className={'dzbn-object-marker'}>
                            <div className={'dzbn-object-marker-title'}>{coord.object_name}</div>
                            <div><span>Наименование заказчика:</span>{coord.client_org_name}</div>
                            <div><span>Инспекционный орган:</span>{coord.inspection_name}</div>
                            <div><span>Регистрационный номер:</span>{coord.registration_number}</div>
                            {dateRegistration}
                        </Popup>
                    </Marker>
                )
            }
        }
    });
    return (
        <LeafletMap
            center={[53, 29]}
            zoom={6}
            maxZoom={18}
            attributionControl={true}
            zoomControl={true}
            doubleClickZoom={true}
            scrollWheelZoom={true}
            dragging={true}
            animate={true}
            easeLinearity={0.35}>
            <TileLayer url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'/>
            <MarkerClusterGroup>
                {markers}
            </MarkerClusterGroup>
        </LeafletMap>
    )
};

const mapState = { center: [53.901437, 27.570577], zoom: 7 };
export class Objects extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            bo_search: '',
            bo: []
        };
    }

    componentWillReceiveProps(nextProps) {
        console.log('Props received');
        console.log(nextProps);
        this.setState(nextProps);
    }

    updateInput = input => {
        this.setState({ bo_search: input.value});
    };
    handleSearch = (e) => {
        e.preventDefault();
        this.props.loadObjects('', 1, e.target['search'].value);
    }

    render () {
        let {classes, bo} = this.props;
        let placeMarks = Array.isArray(bo) ?
            bo.map((item) =>('object_address_lat' in item
            && 'object_address_lon' in item
            && (parseFloat(item.object_address_lon) >=-90) && parseFloat(item.object_address_lat)> -90)?(
                <Placemark
                    key={bo.indexOf(item)}
                    item={item}
                    geometry={{
          coordinates: [parseFloat(item.object_address_lon), parseFloat(item.object_address_lat)]
        }}
                    properties={{
          hintContent: item.object_name,
          balloonContentHeader: item.object_name,
          balloonContentBody: `Наименование заказчика: ${item.client_org_name}. \n
                               Инспекционный орган: ${item.inspection_name}. \n
                               `,

          balloonContentFooter:`Регистрационный номер: ${item.registration_number} | Дата регистрации: ${item.registration_date == null ? 'не указана' : item.registration_date}`


        }} />):''): '';

        const list = Array.isArray(bo) ? (
            bo.map(item => (
                <ExpansionPanel classes={{root: classes.newColor}} key={item.id}>
                    <ExpansionPanelSummary classes={{root: classes.resetPadding}} expandIcon={<ExpandMoreIcon className={classes.color} />}>
                        <Typography className={classes.title}>{item.object_name}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{display: 'block'}}>
                            <Typography component='div' className={classes.blockDescription}><b>Наименование заказчика</b></Typography>
                            <Typography component='div'>{item.client_org_name}</Typography>
                            <Typography component='div' className={classes.blockDescription}><b>Инспекционный орган</b></Typography>
                            <Typography component='div'>{item.inspection_name}</Typography>
                            <Typography component='div' className={classes.blockDescription}><b>Регистрационный номер</b></Typography>
                            <Typography component='div'>{item.registration_number}</Typography>
                            <Typography className={classes.blockDescription}><b>Дата регистрации</b></Typography>
                            <Typography>{item.registration_date}г.</Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            ))
        ) : (<Paper>Искомых объектов не найдено</Paper>);
        return (
            <div>
                <Header />
                <div className={classes.root}>
                    <div  style={{marginRight:'12%', marginLeft:'12%'}}>
                        <Typography component="h2" className={classes.headerStatic} variant="headline">Поднадзорные объекты</Typography>
                        <Typography className={classes.textStatic}>
                            В данный момент карта работает в тестовом режиме. Если вы не нашли интересующий вас объект, просим обратиться в соответствующую инспекцию"
                            <Typography component="div">
                            <Link to="/objects">Посмотреть карту объектов.</Link>
                            </Typography>
                        </Typography>
                        <form onSubmit={this.handleSearch}>
                            <SearchBar placeholderInput='Введите данные объекта для его поиска' textBtn='Поиск' />
                        </form>
                        <div className={classes.maps}>
                            <ObjectsMap objects={this.props.bo}></ObjectsMap>
                        </div>
                        {(this.state.bo_search !== '') &&
                        (<Typography component="div" className={classes.list}>
                            <Typography component="h4" className={classes.subHeader} variant="headline">Результаты поиска</Typography>
                            {list}
                            {(this.props.total > 50)
                            &&(<Pager token={''}
                                      search={this.state.bo_search}
                                      page={this.props.page}
                                      total={this.props.total}
                                      handle={this.props.loadObjects}
                            />)}
                        </Typography>)}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

Objects.defaultProps = {
    bo: [],
    total: 0,
    page: 1

}
function mapDispatch(dispatch) {
    return {
        loadObjects: bindActionCreators(loadObjects, dispatch),
        getTotalPreview: bindActionCreators(getTotalPreview, dispatch),
        getPreview: bindActionCreators(getPreview, dispatch)
    };
}


function select(state, props) {
    const {bo} = state;
    console.log('SELECT');
    console.log(bo);

    return {
        bo: bo.bo || [],
        total: 'total' in  bo ? bo.total : 0,
        page: 'page' in bo ? parseInt(bo.page) : 1
    };
}

// Objects.propTypes = {
//     classes: PropTypes.object.isRequired,
// };

export const ObjectsWithStyles = withStyles(styles)(Objects);

export default connect(select, mapDispatch)(ObjectsWithStyles);


// WEBPACK FOOTER //
// ./assets/src/js/components/pages/ObjectsSearch.jsx